// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9777) return "static/chunks/recorder.4d74e3253d2538b8.js";
	if (chunkId === 12) return "static/chunks/profiler.cde8eb583d3276a2.js";
	if (chunkId === 3167) return "static/chunks/3167.24ee12be886a3a9f.js";
	if (chunkId === 3639) return "static/chunks/3639.3e59a96ab5689ee7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1779":"e6a6c14970573727","2994":"2430b6c51ca9dbbe","3103":"53834b3ea4366abf","5951":"3425f44c0e40d579","9944":"167eb5a3b288f3b8"}[chunkId] + ".js";
};